/**
 * Enum for specifying the scroll behavior when navigating to an anchor.
 */
export enum ScrollBehavior {
  Auto = 'auto', // Scrolls instantly to the anchor.
  Smooth = 'smooth', // Scrolls smoothly to the anchor.
}
